import Vue from 'vue'
import router from '../../router'

// state
export const state = {
    list: [],
    loadedOnce: false,
    prescription: null
}

// getters
export const getters = {
    get: state => state.list,
    prescription: state => state.prescription
}

// mutations
export const mutations = {
    set: (state, doctors) => {
        state.list = doctors
    },

    setPrescription: (state, prescription) => {
        state.prescription = prescription
    }
}

// actions
export const actions = {
    get({ commit, state }, force = false) {
        if (!state.loadedOnce || force) {
            Vue.axios.get('/api/doctors').then((resp) => {
                commit('set', resp.data)
                state.loadedOnce = true;
            }).catch((err) => {
                Vue.$snackbar.show({ message: 'Could not get doctors list.', color: 'error' })
            });
        }

    }
}